import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../../../../common/components/icon/icon.component';
import { FormInputDirective } from '../../../../../../../common/directives/form-input.directive';

@Component({
  selector: 'app-currency-selector',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppIconComponent,
    FormInputDirective,
  ],
  templateUrl: './currency-selector.component.html',
})
export class CurrencySelectorComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() availableCurrencies: string[] = [];
  @Input() currencyWarning: string | null = null;
  @Input() currencyError: string | null = null;

  currencyLabel(code: string): string {
    switch (code?.toUpperCase()) {
      case 'DOP': return 'RD$';
      case 'USD': return 'US$';
      default: return code;
    }
  }
}
